/**
 * Returns a list with stopwords for the English passive voice assessment.
 * @type {Array} The list with stopwords.
 */
export default [
	"to",
	"which",
	"who",
	"whom",
	"that",
	"whose",
	"after",
	"although",
	"as",
	"because",
	"before",
	"even if",
	"even though",
	"if",
	"in order that",
	"inasmuch",
	"lest",
	"once",
	"provided",
	"since",
	"so that",
	"than",
	"though",
	"till",
	"unless",
	"until",
	"when",
	"whenever",
	"where",
	"whereas",
	"wherever",
	"whether",
	"while",
	"why",
	"by the time",
	"supposing",
	"no matter",
	"how",
	"what",
	"won't",
	"do",
	"does",
	"–",
	"and",
	"but",
	"or",
];
